<template>
    <vue-popper
        class="tooltip-button ml-32"
        v-if="tooltipText"
        :content="tooltipText"
        :hover="!isMobile"
        open-delay="200"
        close-delay="100"
        :offset-skid="xOffset"
    >
        <button :aria-label="tooltipText" :class="[
            'ml-1 cursor-help align-[-2px]',
            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
        ]">
            <img src="../../assets/images/icons/info-exclamation.svg" alt="">
        </button>
    </vue-popper>
</template>

<script>
    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],
        props: {
            tooltipText: {
                type: String,
                required: true,
            },
            xOffset: {
                type: String,
                default: '0',
            },
        },

        computed: {
            isMobile() {
                return this.appStore?.isMobile;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .tooltip-button {
        --popper-theme-background-color: #000;
        --popper-theme-background-color-hover: #000;
        --popper-theme-text-color: #fff;
        --popper-theme-border-width: 0px;
        --popper-theme-border-radius: 0px;
        --popper-theme-padding: 20px;
        --popper-theme-box-shadow: 0 3px 5px rgba(15, 15, 15, 0.26);
    }

    :deep(.popper) {
        max-width: 300px;
        font-family: Gotham Narrow SSm A, Gotham Narrow SSm B, sans-serif;
        font-weight: normal;
        font-size: 14px;
        line-height: 1;
    }
</style>
